module.exports = __webpack_public_path__ + "img/zhinengjiaju1.4f986d12.jpg";